module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPAAAADwAgMAAABDOwEBAAAADFBMVEVHcEyjo6O8vLyjo6N6TnL5AAAAA3RSTlMApQLHCO1eAAAAs0lEQVRo3u3asQ2CQACF4YOG6BKuwihu4m2CpeNYMgixM6cryCMh6vf3L+QTmotXiiRJkn6jYw3G3T0YD0swPj2D8aWNwZNbgB5agO4aNDQ0NPR69JygHxG6JugzNDQ0NDQ0NDQ09D+hl53QfXLgOCRPfpvXj6fk107ec0gOvm1kZGRkZGRkZGRk5G2PUlPyr1F4kirIyMjIX0jObixFd6WiW1p9Tca3ZHwNxiUaS5IkfdwL6TNJAjnDnqwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/views/concierge/images/concierce_voucher_right.png
// module id = mz1w
// module chunks = 0